import { Button, Modal, ModalBody } from "reactstrap";

function ModalBox({
  open,
  onClose,
  backdrop = "static",
  keyboard = false,
  children,
  showCloseButton = false,
}) {
  return (
    <Modal
      className="modal-box-container"
      backdropClassName="modal-box-backdrop"
      fade
      isOpen={open}
      toggle={() => onClose(false)}
      centered
      size="lg"
      backdrop={backdrop}
      keyboard={keyboard}
    >
      <ModalBody className="modal-box-body">
        {showCloseButton && (
          <Button
            type="button"
            color="link"
            className="close-link-btn"
            onClick={() => onClose(false)}
          >
            Close
          </Button>
        )}
        {children}
      </ModalBody>
    </Modal>
  );
}

export default ModalBox;
